import { render, staticRenderFns } from "./check_task.vue?vue&type=template&id=1f23d52a&scoped=true&"
import script from "./check_task.vue?vue&type=script&lang=js&"
export * from "./check_task.vue?vue&type=script&lang=js&"
import style0 from "./check_task.vue?vue&type=style&index=0&id=1f23d52a&scoped=true&lang=css&"
import style1 from "./check_task.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f23d52a",
  null
  
)

export default component.exports